const inboundReferralsRoutes = [
    {
        path: '/inbound_referrals',
        name: 'inboundReferrals',
        children: [
            {
                path: '',
                name: 'inboundReferralsList',
                component: () => import('@/modules/inbound_referrals/list/List.vue'),
                meta: {
                    resource: 'inbound-referrals',
                    action: 'view',
                    layout: 'default',
                    auth: true,
                    title: 'Inbound Referrals',
                    breadcrumbs: [{ title: 'Inbound Referrals', routeName: 'inboundReferralsList' }]
                }
            }
        ]
    }
]

export default inboundReferralsRoutes
